import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import Input from '../../../../components/forms/input.component';
import Icon from '../../../../components/forms/icon.component';
import Select from 'react-select';
import InvalidFeedback from '../../../../components/forms/invalid-feedback.component';
import useInputValidation from '../../../../hooks/use-input-validation.hook';

interface PhoneNumberBtnProps {
  errors: any;
  register: any;
  control: any;
  watch: any;
  index: number;
  onDelete: () => void;
}

const PhoneNumberBtn: React.FC<PhoneNumberBtnProps> = ({
  errors,
  register,
  control,
  watch,
  index,
  onDelete
}) => {
  const { t } = useTranslation();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, maxLength: number) => {
    const currentLength = e.currentTarget.value.length;
    if (currentLength >= maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  const countryOptions = [{ value: '52', label: 'Mex (+52)' }];

  const { phoneNumberRegex } = useInputValidation();

  const validatePhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber.match(phoneNumberRegex)) {
      return false;
    }
    return true;
  };

  return (
    <div className="border p-7 mt-4">
      <div className="mb-2">
        <i className="bi-telephone me-2"></i>
        {t('templates.wa.create.call-phone')}
      </div>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center">
          <div className="me-2 d-flex gap-4 w-100">
            <div className="d-block mw-150px">
              <label className="form-label required">
                {t('templates.wa.create.country-label')}
              </label>
              <Controller
                control={control}
                name={`buttons.buttons.${index}.country_code`}
                defaultValue={'+1'}
                rules={{ required: true }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <>
                    <Select
                      options={countryOptions}
                      noOptionsMessage={({ inputValue }) =>
                        inputValue
                          ? t('general.no-options', { inputValue })
                          : t('general.no-options')
                      }
                      className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                      classNamePrefix="form-select-custom"
                      onChange={(selectedOption: { value: string; label: string } | null) => {
                        onChange(selectedOption ? selectedOption.value : null);
                      }}
                      value={countryOptions.find((option) => option.value === value) || null}
                    />
                    <InvalidFeedback error={error} />
                  </>
                )}
              />
            </div>
            <div className="flex-grow-1">
              <Input
                label={t('templates.wa.create.text-btn-label')}
                errors={errors?.text}
                requiredIndicator="required"
                currentLength={watch(`buttons.buttons.${index}.text`)?.length}
                maxLength={25}
                placeholder={t('templates.wa.create.body-placeholder')}
                onKeyDown={(e: any) => handleKeyDown(e, 25)}
                {...register(`buttons.buttons.${index}.text`, {
                  required: true,
                  maxLength: { value: 25, message: '25' },
                  setValueAs: (value: string) => value.trim()
                })}
              />
            </div>
            <div className="flex-grow-1">
              <Input
                label={t('templates.wa.create.phone-number-label')}
                errors={errors?.phone_number}
                requiredIndicator="required"
                type="number"
                currentLength={watch(`buttons.buttons.${index}.phone_number`)?.length}
                maxLength={20}
                placeholder={t('templates.wa.create.number-placeholder')}
                onKeyDown={(e: any) => handleKeyDown(e, 20)}
                {...register(`buttons.buttons.${index}.phone_number`, {
                  required: true,
                  pattern: {
                    value: phoneNumberRegex,
                    message: 'Numero entre 6 y 20 caracteres'
                  },
                  validate: validatePhoneNumber,
                  maxLength: { value: 20, message: '20' },
                  setValueAs: (value: string) => value.trim()
                })}
              />
            </div>
          </div>
          <a className="btn btn-light-danger btn-icon ms-1 mt-4" onClick={onDelete}>
            <Icon icon="ki-trash" size="fs-2x" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberBtn;
